<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="6" :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
      <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12" class="pb-0">
            <div class="text-md-h4 text-h5" :style="textColor">General Financial Information</div>
          </v-col>
          <v-col cols="12" class="pb-1">
            <div class="text-subtitle-2 font-italic">*The information below is not required for initial proposal but it is required for final underwriting and contract submission.</div>
          </v-col>
          <v-col cols="12" class="text-body-2">
            <div>{{ messages.GeneralFinanceMessage }}</div>
          </v-col>

          <v-col cols="12" class="mt-4">
            <div class="text-md-body-1 text-body-2">Owner/President Information</div>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="Owner/President's Name"
              class="rounded-lg"
              hide-details
              v-model="ownerName"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Social Security Number"
              class="rounded-lg"
              hide-details
              v-model="ssn"
              type="password"
              v-mask="'###-##-####'"
              maxLength="11"
            ></v-text-field>
          </v-col>

          <!-- Date of Birth -->
          <v-col cols="12" sm="6">
            <v-menu
              ref="dobMenu"
              v-model="dobMenu"
              :close-on-content-click="false"
              :return-value.sync="ownerDOB"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="ownerDOB"
                  outlined
                  label="Date of Birth"
                  class="rounded-lg"
                  hide-details
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="ownerDOB"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="dobMenu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dobMenu.save(ownerDOB)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="Home Street Address"
              class="rounded-lg"
              hide-details
              v-model="ownerAddress"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="City"
              class="rounded-lg"
              hide-details
              v-model="ownerCity"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-combobox
              v-model="ownerState"
              :items="states"
              item-value="Abbr"
              item-text="Full"
              outlined
              label="State"
              class="rounded-lg"
              hide-details=""
              :return-object="false"
            ></v-combobox>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              outlined
              label="Postal Code"
              class="rounded-lg"
              hide-details
              v-model="ownerZip"
            ></v-text-field>
          </v-col>

          <!-- Date -->
          <v-col cols="12">
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :return-value.sync="companyInfoDate"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="companyInfoDate"
                  outlined
                  label="Date"
                  class="rounded-lg"
                  hide-details
                  append-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="companyInfoDate"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="dateMenu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dateMenu.save(companyInfoDate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col cols="12" class="mt-4">
            <div class="text-md-body-1 text-body-2">Bank Reference Information</div>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="Bank Name"
              class="rounded-lg"
              hide-details
              v-model="bankName"
            ></v-text-field>
          </v-col>

          <v-col cols="8">
            <v-text-field
              outlined
              label="Primary Bank Contact"
              class="rounded-lg"
              hide-details
              v-model="bankContactName"
            ></v-text-field>
          </v-col>

          <v-col cols="4">
            <v-text-field
              outlined
              label="Contact Phone"
              class="rounded-lg"
              hide-details
              v-model="bankContactPhone"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Account Number"
              class="rounded-lg"
              hide-details
              v-model="accountNumber"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Email Address"
              class="rounded-lg"
              hide-details
              v-model="bankContactEmail"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            class="mt-5 pb-0"
          >
            <div class="text-md-body-1 text-body-2">Are you delinquent on any accounts?</div>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 blue-text text--darken-4">If yes, please provide additional details</div>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-radio-group
              v-model="hasDelinquency"
              mandatory
              row
              class="mt-0"
            >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Additional Details *"
              class="rounded-lg"
              hide-details
              v-show="hasDelinquency === true"
              v-model="delinquencyExplanation"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            class="mt-5 pb-0"
          >
            <div class="text-md-body-1 text-body-2">Have you or your ﬁrm ever been placed for collection, had liens ﬁled against you, had legal action taken against you, or filed bankruptcy?</div>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 blue-text text--darken-4">If yes, please provide additional details</div>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-radio-group
              v-model="hasCollections"
              mandatory
              row
              class="mt-0"
            >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Additional Details *"
              class="rounded-lg"
              hide-details
              v-show="hasCollections === true"
              v-model="collectionExplanation"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            class="mt-5 pb-0"
          >
            <div class="text-md-body-1 text-body-2">Currently or in the last five years has the business been involved in a government investigation, inquiry or private adversary action? For example, but not by limitation, an audit by the Bureau of Workers' Compensation, any administrative proceeding (including but not limited to EEOC, FCHR, OFCCP, NLRB, OSHA, and Wage and Hour matters), civil or criminal investigation, lawsuit, or other adversary proceeding, including those which are pending or threatened, as well as those not yet asserted.</div>
          </v-col>
          <v-col cols="12">
            <div class="text-subtitle-2 blue-text text--darken-4">If yes, please provide additional details</div>
          </v-col>
          <v-col cols="12" class="pt-0">
            <v-radio-group
              v-model="legalMixFlag"
              mandatory
              row
              class="mt-0"
            >
                <v-radio
                  label="Yes"
                  :value="true"
                ></v-radio>
                <v-radio
                  label="No"
                  :value="false"
                ></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              label="Additional Details *"
              class="rounded-lg"
              hide-details
              v-show="legalMixFlag === true"
              v-model="legalMixExplanation"
            ></v-text-field>
          </v-col>

          <BtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import Messages from '@/Data/Messages';
import States from '@/Data/States';
import BtnContinue from '../../btnContinue.vue';

export default {
  name: 'StepSix',
  components: {
    BtnContinue,
  },
  data: () => ({
    messages: Messages,
    states: States,
    dobMenu: false,
    dateMenu: false,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    contactId() {
      return this.$store.state.prospectPacket.companyInfo.ownerContactType;
    },
    contact: {
      get() {
        return this.$store.state.prospectPacket.contacts.find((x) => x.contactType === this.contactId);
      },
      set(value) {
        this.$store.state.commit('updateContactObject', value);
      },
    },
    bankContactType() {
      return this.$store.state.prospectPacket.bankInformation.contactType;
    },
    bankContact: {
      get() {
        return this.$store.state.prospectPacket.contacts.find((x) => x.contactType === this.bankContactType);
      },
      set(value) {
        this.$store.state.commit('updateContactObject', value);
      },
    },
    bankContactName: {
      get() {
        if (this.bankContact === undefined) {
          return '';
        }
        return this.bankContact.name;
      },
      set(value) {
        this.bankContact.name = value;
      },
    },
    bankContactPhone: {
      get() {
        if (this.bankContact === undefined) {
          return '';
        }
        return this.bankContact.phone;
      },
      set(value) {
        this.bankContact.phone = value;
      },
    },
    bankContactEmail: {
      get() {
        if (this.bankContact === undefined) {
          return '';
        }
        return this.bankContact.email;
      },
      set(value) {
        this.bankContact.email = value;
      },
    },
    ownerName: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.name;
      },
      set(value) {
        this.contact.name = value;
      },
    },
    ownerAddress: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.address1;
      },
      set(value) {
        this.contact.address1 = value;
      },
    },
    ownerCity: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.city;
      },
      set(value) {
        this.contact.city = value;
      },
    },
    ownerState: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.state;
      },
      set(value) {
        this.contact.state = value;
      },
    },
    ownerZip: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.zip;
      },
      set(value) {
        this.contact.zip = value;
      },
    },
    ssn: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.ssn;
      },
      set(value) {
        this.$store.commit('updateCompanySSN', value);
      },
    },
    ownerDOB: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.ownerDOB;
      },
      set(value) {
        this.$store.commit('updateOwnerDOB', value);
      },
    },
    companyInfoDate: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.date;
      },
      set(value) {
        this.$store.commit('updateCompanyDate', value);
      },
    },
    bankName: {
      get() {
        return this.$store.state.prospectPacket.bankInformation.bankName;
      },
      set(value) {
        this.$store.commit('updateBankName', value);
      },
    },
    accountNumber: {
      get() {
        return this.$store.state.prospectPacket.bankInformation.accountNumber;
      },
      set(value) {
        this.$store.commit('updateAccountNumber', value);
      },
    },
    hasDelinquency: {
      get() {
        return this.$store.state.prospectPacket.flags.hasDelinquency;
      },
      set(value) {
        this.$store.commit('updateHasDeliquency', value);
      },
    },
    hasCollections: {
      get() {
        return this.$store.state.prospectPacket.flags.hasCollections;
      },
      set(value) {
        this.$store.commit('updateHasCollections', value);
      },
    },
    legalMixFlag: {
      get() {
        return this.$store.state.prospectPacket.flags.legalMix;
      },
      set(value) {
        this.$store.commit('updateLegalMixFlag', value);
      },
    },
    collectionExplanation: {
      get() {
        return this.$store.state.prospectPacket.bankInformation.collectionExplanation;
      },
      set(value) {
        this.$store.commit('updateCollectionExplanation', value);
      },
    },
    delinquencyExplanation: {
      get() {
        return this.$store.state.prospectPacket.bankInformation.delinquencyExplanation;
      },
      set(value) {
        this.$store.commit('updateDelinquencyExplanation', value);
      },
    },
    legalMixExplanation: {
      get() {
        return this.$store.state.prospectPacket.bankInformation.legalMixExplanation;
      },
      set(value) {
        this.$store.commit('updateLegalMixExplanation', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
